import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MenuBar from "../../components/menu-bar/MenuBar";
import Slider from "react-slick";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import { formatCurrency } from "../../common/format-currency";
import { useMediaQuery } from "react-responsive";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "react-loader-spinner";
import RenderItem from "../../common/renderItem";
import ContentLoader from "react-content-loader";
import { SpinnerCircular } from "spinners-react";
import ProgressBar from "@ramonak/react-progress-bar";
import {
  UpdateCartCount,
  UpdateCartAmount,
  setACF,
} from "../../redux/actions/postActions";
import _ from "lodash";
import { KMTracking } from "../../components/Tracking/KMTracking";
import cleanURL from "../../common/cleanURL";
import { Link } from "react-router-dom";

const sortOptions = [
  { label: "Latest", value: "-created" },
  { label: "Best Match", value: "name" },
  { label: "Price Low to High", value: "price" },
  { label: "Price High to Low", value: "-price" },
];
const MyLoader = () => (
  <ContentLoader viewBox="0 0 1000 400">
    <rect x="3" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="350" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="700" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="3" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="350" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="700" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="3" y="330" rx="4" ry="4" width="175" height="28" />
    <rect x="3" y="371" rx="4" ry="4" width="131" height="33" />
    <rect x="350" y="330" rx="4" ry="4" width="300" height="29" />
    <rect x="350" y="371" rx="4" ry="4" width="116" height="30" />
    <rect x="700" y="330" rx="4" ry="4" width="173" height="29" />
    <rect x="700" y="371" rx="4" ry="4" width="200" height="31" />
  </ContentLoader>
);
function Search(props) {
  const [products, setProducts] = useState<any>([]);
  const [selectedSort, setSelectedSort] = useState<any>(sortOptions[0]);
  const [trendingProducts, setTrendingProducts] = useState<any>([]);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  const [productCount, setProductCount] = useState(0);
  const [moreProductsAvailable, setMoreProductsAvailable] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [prevProps, setPrevProps] = useState("");
  const [is_loading, setIsLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [allProductLength, setAllProductLength] = useState<any>();
  const [DeliveryID,setDeliveryID]= useState("")

  var ACF;
  useEffect(() => {
    let ACFData:any = localStorage.getItem("ACF")
    let Deliveryid =JSON.parse(ACFData)?.FrasersDeliveryItemID
    setDeliveryID(Deliveryid)
    setPageNumber(1);
    getTrendingProducts();
    if (props?.match?.params?.keywords) {
      const keywords = props?.match?.params?.keywords
        .replace(/-/g, " ")
        .replace(/%/g, "")
        .replace(/-/g, "");
      setPrevProps(keywords);
      fetchProducts(1, keywords);
      const data = {
        search_term: keywords,
        "Search query": keywords,
      };
      tracker("storesearch", data);
      tracker("search", data)
    }
    if (props?.history?.location) {
      window.scrollTo(0, 0);
    }
  }, [selectedSort, props?.match?.params?.keywords]);
  useEffect(() => {
    if (prevProps != props?.match?.params?.keywords) {
      setProducts([]);
    }
    setPageNumber(1);
    getTrendingProducts();
    if (props?.match?.params?.keywords) {
      const keywords = props?.match?.params?.keywords
        .replace(/_/g, " ")
        .replace(/%/g, "")
        .replace(/-/g, " ");
      fetchProducts(1, keywords);
    }
    if (props?.history?.location) {
      window.scrollTo(0, 0);
    }
  }, [props]);
  const tracker = async (eventName, _kmprops) => {
    await KMTracking(eventName, _kmprops);
  };
  const getTrendingProducts = async () => {
    if (!_.isEmpty(props?.acf)) {
      ACF = props?.acf;
    } else {
      ACF = await new WebApiCalls().getCustomFieldsCode(true);
      props.setACF(ACF);
    }
    let customFieldQueries;
    if (ACF["Trending"] !== undefined) {
      customFieldQueries = [
        {
          Code: ACF["Trending"],
          Operator: "equal",
          Value: "1",
        },
      ];
    } else {
      customFieldQueries = [
        {
          Code: ACF["trending"],
          Operator: "equal",
          Value: "1",
        },
      ];
    }
    let tempArr: any = [];
    let itemObj = {
      CustomFieldQueries: customFieldQueries,
      Sort: "brand",
    };
    let accessToken = await localStorage.getItem("access_token");
    await new WebApiCalls()
      .getItemsByFilters(itemObj, accessToken)
      .then((_response) => {
        if (_response?.Records) {
          tempArr = _response.Records;
        }
      })
      .catch((error) => console.log("Error: ", error));

    tempArr = tempArr.filter((item) => item.ID);
    // const slicedArray = tempArr.slice(0, 5);
    setTrendingProducts(tempArr);
  };
  const fetchProducts = async (pageNumber, item) => {
    if (pageNumber == 1) {
      setIsLoading(true);
    }
    item = item.replace(/%/g, "").replace(/_/g, " ").replace(/-/g, " ");
    let itemObj = {
      _created: "",
      updated: "",
      _updated: "",
      price: "",
      _price: "",
      pageSize: 20,
      Sort: selectedSort?.value ? selectedSort?.value : "name",
      pageNumber: pageNumber ? pageNumber : 1,
      keywords: item?.length > 0 ? item : "",
    };
    let _products: any = [];

    await new WebApiCalls().getItems(itemObj).then((response) => {
      setAllProductLength(response?.TotalRecords);
      if (productCount == response?.Records?.length) {
        setProductCount(response?.Records?.length + 1);
        setLoader(false);
      } else {
        setProductCount(response?.Records?.length);
        setLoader(false);
      }
      if (response.Records.length > 0) {
        // let temp: any = []
        response.Records.map((item: any) => {
          if (
            item?.ID == DeliveryID
          ) {
            setAllProductLength(response.TotalRecords-1);
            return;
          } else {
            const BrandName = item?.CustomFields
              ? item?.CustomFields?.length > 0
                ? item?.CustomFields?.filter((item) =>
                    item?.Name?.includes("Brand")
                  ).length > 0
                  ? item?.CustomFields.filter((item) =>
                      item?.Name?.includes("Brand")
                    )[0]?.Values[0]
                  : ""
                : ""
              : "";
            item.Price = formatCurrency(item?.Price);
            item.BrandName = BrandName;
            _products = [..._products, item];
          }
        });
        if (pageNumber == 1) {
          // setProducts(_.uniqBy(_products, "ID"));
          setProducts(_products);
        } else {
          setProducts(products.concat(_.uniqBy(_products, "ID")));
        }
      } else {
        setMoreProductsAvailable(false);
      }
      setIsLoading(false);
    });
  };

  function NextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "rgba(255, 255, 255, 0.5)",
          top: isTabletOrMobileDevice || isTabletOrMobile ? "25%" : "35%",
          marginRight: "10px",
        }}
        onClick={onClick}
      >
        <div className="slick-next">
          <img src="images/next.png" />
        </div>
      </div>
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "rgba(255, 255, 255, 0.5)",
          top: isTabletOrMobileDevice || isTabletOrMobile ? "25%" : "35%",
          marginLeft: "10px",
        }}
        onClick={onClick}
      >
        <div className="slick-prev">
          <img src="images/prev.png" />
        </div>
      </div>
    );
  }
  const renderMiniSlider = (imgArray: any, slides: number) => {
    let settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: slides,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 3000,
      centerMode: false,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    };
    return (
      <Slider {...settings}>
        {imgArray?.map((item: any, index: number) => {
          if (!item.ID) {
            return;
          }
          return (
            <RenderItem
              key={index}
              item={item}
              onClickItem={onClickItem}
              is_slider={true}
              from={"Search"}
            />
          );
        })}
      </Slider>
    );
  };
  const onClickItem = (_item) => {
    props?.history?.push(`/product/${cleanURL(_item.Name)}/${_item.ID}`, {
      from: "Search",
    });
  };
  return (
    <div>
      <div className="viewport"></div>

      {/* /container */}
      <div className="container">
        {/* header */}
        <Header props={props} />
        {/* /header */}

        <MenuBar
          props={props}
          categoriesArray={props?.allCategories ? props?.allCategories : []}
        />

        {/*/content */}

        <div className="content">
          {/*breadcrumb */}
          <div
            className="breadcrumb"
            style={{ backgroundColor: "rgb(255,255,255,0.3)" }}
          >
            <Link to="/">Home</Link>
            <a href="#">Search</a>
          </div>
          {/*/breadcrumb */}

          {/*product listing */}
          {is_loading ? (
            <MyLoader />
          ) : products?.length ? (
            <div className="product-listing">
              <div className="search-filter-wrap">
                {/*search results */}
                <div className="search-results">
                  Search results for '
                  <div className="keyword">
                    {props?.match?.params?.keywords
                      ? props.match.params.keywords
                          .replace(/-/g, " ")
                          .replace(/-/g, "")
                      : ""}
                  </div>
                  '
                </div>
                {/*/search results */}

                {/*filter */}
                <div className="filter full">
                  <div className="text">Sort by</div>
                  <select
                    name="sortby"
                    id="sortby"
                    onChange={(e: any) => {
                      setPageNumber(1);
                      let selecteOption = sortOptions.find(
                        (option) => option.value == e.target.value
                      );
                      setSelectedSort(selecteOption);
                      let kmFilterValuesProps = {
                        "Filter Type": "SORT BY",
                        "Sort Value": selecteOption,
                      };
                      tracker("appliedfilter", kmFilterValuesProps);
                    }}
                  >
                    {sortOptions?.map((item: any, index: number) => {
                      return (
                        <option key={index} value={item?.value}>
                          {item?.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="slide-sortby">
                  <div className="title">SORT BY</div>
                  <a href="#">Best Match</a>
                  <a href="#">Price (High)</a>
                  <a href="#">Price (Low)</a>
                </div>
              </div>
              <div
                style={{
                  justifyContent: "center",
                  marginLeft: !isTabletOrMobileDevice ? "100" : "",
                }}
              >
                <div
                  className="products"
                  style={{
                    width: "100%",
                    marginTop: isTabletOrMobileDevice ? 18 : 0,
                  }}
                >
                  {products?.map((item: any, index: number) => {
                    if (
                      item?.ID != DeliveryID
                    ) {
                      return (
                        <RenderItem
                          key={index}
                          is_slider={false}
                          item={item}
                          onClickItem={onClickItem}
                          from={"Search"}
                        />
                      );
                    }
                  })}
                  <i aria-hidden={true}></i>
                  <i aria-hidden={true}></i>
                </div>
                <div style={{ textAlign: "center" }} className="load-more-sec">
                  <div
                    style={{
                      fontFamily: "Montserrat",
                      fontSize: "11px",
                      lineHeight: "20px",
                      color: "#666",
                    }}
                  >
                    {`You've viewed ${products.length} of ${allProductLength}
                          products`}
                  </div>
                  <ProgressBar
                    className="progress-bar"
                    isLabelVisible={false}
                    maxCompleted={parseInt(allProductLength)}
                    completed={products.length}
                    height="2px"
                    width="100%"
                    bgColor="#000000"
                  />
                </div>
                {parseInt(allProductLength) !== products.length && (
                  <div style={{ textAlign: "center" }}>
                    {!loader ? (
                      <button
                        style={{
                          fontFamily: "Montserrat",
                          fontSize: "12px",
                          backgroundColor: "#ffffff",
                          color: "#000000",
                          padding: "10px 60px",
                          border: "1px solid #DDDDDD",
                          cursor: "pointer",
                          letterSpacing: "1.5px",
                          fontWeight: 500,
                        }}
                        onClick={() => {
                          setPageNumber(pageNumber + 1);
                          if (props?.match?.params?.keywords.length > 0) {
                            fetchProducts(
                              pageNumber + 1,
                              props?.match?.params?.keywords
                            );
                            setLoader(true);
                          }
                        }}
                        className="btn"
                      >
                        LOAD MORE
                      </button>
                    ) : (
                      <SpinnerCircular
                        color="black"
                        size="33"
                        thickness={170}
                        speed={200}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="product-listing">
              <div className="search-filter-wrap">
                <div className="search-results">
                  We could not find anything for '
                  <div className="keyword">
                    {props?.match?.params?.keywords
                      ?.replace(/_/g, " ")
                      .replace(/-/g, " ")}
                  </div>
                  '
                  <br />
                  <br />
                  <a href="#" className="blackbutton">
                    Shop now
                  </a>
                </div>
              </div>
              <section className="related">
                <div className="title capitalize">
                  These popular items might interest you
                </div>
                <div className="minicarousel four">
                  {isTabletOrMobile || isTabletOrMobileDevice
                    ? renderMiniSlider(trendingProducts, 2)
                    : renderMiniSlider(trendingProducts, 4)}
                </div>
              </section>
            </div>
          )}
        </div>
        {/* /content*/}
      </div>

      <Footer
        props={props}
        categoriesArray={props?.allCategories ? props?.allCategories : []}
      />
    </div>
  );
}
const mapStateToProps = (state) => {
  const { cart_count, acf, allCategories } = state.UserReducer;
  return { cart_count, acf, allCategories };
};
const actions = {
  UpdateCartCount,
  UpdateCartAmount,
  setACF,
};
export default connect(mapStateToProps, actions)(Search);
